<!--
=========================================================================================
    Message Card
==========================================================================================
-->

<!-- 
  - Show Webboard UI with Fast Reply
    [ ] Show Thread Title
    [ ] Show Thread Author      
    [ ] Show Thread Last 10 Replies
    [ ] Show Thream Created Time
    [ ] Show Reply Box          
      [ ] Show Reply Text Area  
      [ ] Show Reply Send Button
-->                             
                                
<template>                      
  <div>                         
    <MessageHeader :data="data" :show-content="false" />
    <vx-card class="mt-base">   
                                     
      <div class="webboard-reply-bubble">
        <template v-for="reply in createReplyList({ offset, limit })">
          <div :key="reply.id" >     
            <!-- {{ reply }} -->     
            <div class="reply-message">
              {{ reply.content }}    
            </div>                   
            <div class="reply-by">   
              <span v-if="reply.role === 'teacher'">
                {{ $t('general.teacher')}}
              </span>                
              {{ reply.user_name[_i18n.locale] }}
            </div>                   
            <div class="reply-date"> 
              {{ reply.date }}       
            </div>                   
            <hr />                   
          </div>                     
        </template>                  
      </div>                         
                                     
    </vx-card>                       
  </div>                             
</template>                          
                                     
<script>                             
export default {                     
  // inject: {                       
  //   components: {                 
  //     default: {                  
  //       WeboardUI: () => import("@/developing/components/chat")
  //     }                           
  //   }                             
  // },                              
  components: {                      
    MessageHeader: () => import("./MessageHeader")
  },                                 
  props: {                           
    data: {                          
      type: Object,                  
      required: true                 
    }                                
  },                                 
  data() {                           
    return {                         
      offset: 0,                     
      limit: 10,                     
    }                                                                
  },                                                                 
  methods: {                                                         
    createReplyList(options = {                                      
      offset: 0,                                                     
      limit: 10                                                      
    }) {                                                             
      const replyList = [];                                          
      const { offset, limit } = options;                             
                                                                     
      if (Array.isArray(this.data.webBoardReplies) && this.data.webBoardReplies.length > 0) {
        const max = Math.min(this.message.webBoardReplies.length - 1, offset + limit);
                                                                     
        for (let i = offset; i <= max; i++) {                        
          const _reply = this.message.webBoardReplies[i];            
                                                                     
          const role = _reply.teacher ? "teacher" : "student";       
          const code = role === "teacher" ? _reply.teacherCode : _reply.studentCode;
          const user = role === "teacher" ? _reply.teacher : _reply.student || null;
          const user_id = user ? user.id : null;                     
          const user_name_local = user ? user.firstNameLocal + " " + user.lastNameLocal : null;
          const user_name_eng = user ? user.firstNameEng + " " + user.lastNameEng : null;
                                                                     
          const reply = {                                            
            id: _reply.id,                                           
            original: _reply,                                        
            user,                                                    
            user_id,                                                 
            user_name: {                                             
              local: user_name_local,                                
              th: user_name_local,                                   
              en: user_name_eng                                      
            },                                                       
            content: _reply.replyMessage,                            
            role, code,                                              
            date: _reply.updatedAt,                                  
          };                                                         
                                                                     
          replyList.push(reply);                                     
        }                                                            
      }                                                              
                                                                     
      return replyList;                                              
    }                                                                
  }                                                                  
}                                                                    
</script>                                                            
                                                                     
<style lang="scss" scoped>                                           
.webboard-reply-bubble {                                             
	position: relative;                                                 
	max-width: 30em;                                                    
	background-color: #fff;                                             
	padding: 1.125em 1.5em;                                             
  font-size: 1.25em;                                                 
  border-radius: 12px;                                               
  box-shadow: 0 0.125rem 0.1rem rgba(0, 0, 0, 0.2), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);
                                                                     
  &._topic {                                                         
    box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2), 0 0.125rem 0.1rem rgba(0, 0, 0, 0.2);
    background: #fafafa;                                             
    max-width: 100% !important;                                      
                                                                     
    ::before {                                                       
      // layout                                                      
      content: '';                                                   
      position: absolute;                                            
      width: 0;                                                      
      height: 0;                                                     
      bottom: 96%;                                                   
      left: 1.2em; // offset should move with padding of parent      
      border: .75rem solid transparent;                              
      border-top: none;                                              
                                                                     
      // looks                                                       
      // background: #fafafa;                                        
      border-bottom-color: #f7f7f7;                                  
      filter: drop-shadow(0 -1px 1px rgba(0, 0, 0, 0.05));           
    }                                                                
  }                                                                  
                                                                     
  &._reply {                                                         
                                                                     
    margin-left: auto;                                               
    text-align: right;                                               
                                                                     
    &::before {                                                      
      // layout                                                      
      content: '';                                                   
      position: absolute;                                            
      width: 0;                                                      
      height: 0;                                                     
      bottom: 20%;                                                   
      right: -1.1rem; // offset should move with padding of parent   
      border: .75rem solid transparent;                              
      border-top: none;                                              
                                                                     
      // looks                                                       
      border-bottom-color: #fff;                                     
      filter: drop-shadow(0 -0.0625rem 0.0625rem rgba(0, 0, 0, .2)); 
      transform: rotate(90deg);                                      
    }                                                                
  }                                                                  
                                                                     
  &._response {                                                      
                                                                     
    &::before {                                                      
      // layout                                                      
      content: '';                                                   
      position: absolute;                                            
      width: 0;                                                      
      height: 0;                                                     
      bottom: 60%;                                                   
      left: -1rem; // offset should move with padding of parent      
      border: .75rem solid transparent;                              
      border-top: none;                                              
                                                                     
      // looks                                                       
      border-bottom-color: #fff;                                     
      filter: drop-shadow(0 -0.0625rem 0.0625rem rgba(0, 0, 0, 0.2));
      transform: rotate(-90deg);                                     
    }                                                                
  }                                                                  
}                                                                    